import { create } from "zustand";
import type { StartupStore } from "./startup.types";

/** Written only by `conversation-session`'s start; the apps read it to show the warmup notice. */
export const useStartupStore = create<StartupStore>(() => ({ status: "idle", startedAt: 0 }));

export const useStartupStatus = () => useStartupStore((state) => state.status);
export const useStartupStartedAt = () => useStartupStore((state) => state.startedAt);
